import ComparisonContextBase from "./comparisonContextBase";
import { EyeTypes, OCTBrowserType } from "../config/config";
import store from "../store";

export default class SpectralisComparisonBrowserContext extends ComparisonContextBase {
  constructor(exam, eye, launchOption, scanTypeFilter, selectedScan) {
    super(exam, eye, [OCTBrowserType.Spectralis], OCTBrowserType.Spectralis, "spectralisComparisonBody", "Spectralis Multiview", launchOption);
    
    this.showThicknessMap = false;
    this.thicknessMapOpacity = 1.0;
    this.thicknessDifference = 0.0;

    this.bothMeasuring = false;

    this.isSpectralisComparison = true;
    this.scanTypeFilter = scanTypeFilter;
    this.reloadImages = false;
    this.selectedScan = selectedScan;
  }

  get exams() {
    let exams, groupSplitExams = [];
    exams = this.eye === EyeTypes.OD ? this.odExams : this.osExams;
    let groupkey = this.eye === EyeTypes.OD ? "odGroups" : "osGroups";
    exams.forEach(e => {
      let test = store.getters.groups(e, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)
      if (test.length > 1) {
        groupSplitExams.push(...this.generateExamsFromGroup(e, groupkey));
      }
      else {
        if (!e.octDateButtonText.includes(store.getters.groups(e, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].groupSeriesType))
          e.octDateButtonText = e.dateDisplay + " - " + store.getters.groups(e, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].groupSeriesType + " (" + e.exSrNo + ")";
        e.scanType = store.getters.groups(e, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].scanType;
        groupSplitExams.push(e);
      }
    });
    if (this.scanTypeFilter != "All") {
      if (this.scanTypeFilter == "Radial")
        return groupSplitExams.filter(e => {
          return e.scanType == "star";
        });
      return groupSplitExams.filter(e => {
        return e.scanType == this.scanTypeFilter.toLowerCase();
      });
    }
    return groupSplitExams;
  }

  get examTypes() { 
    let exams, groupKey;
    let examTypes = ["All"];
    if (this.eye === EyeTypes.OD) {
      exams = this.odExams;
      groupKey = "odGroups";
    }
    else {
      exams = this.osExams;
      groupKey = "osGroups";
    }

    exams.forEach(e => {
      e[groupKey].forEach(f => {
        if (!examTypes.includes(f.scanType.charAt(0).toUpperCase() + f.scanType.slice(1)) && f.browserType == 1) {
          if (f.scanType.toUpperCase() == "STAR")
            examTypes.push("Radial");
          else
            examTypes.push(f.scanType.charAt(0).toUpperCase() + f.scanType.slice(1));
        }
      });
    });

    return examTypes;
  }

  startupTask() {
    let groups = this.eye === EyeTypes.OD ? this.exam.odGroups : this.exam.osGroups, group;
    if (this.scanTypeFilter == "Radial")
      group = groups.find(g => g.recognized && g.browserType === this.preferredBrowserType && g.scanType == "star");
    else if (this.scanTypeFilter == "All")
      group = groups.find(g => g.recognized && g.browserType === this.preferredBrowserType);
    else
      group = groups.find(g => g.recognized && g.browserType === this.preferredBrowserType && g.scanType == this.scanTypeFilter.toLowerCase());
    return this.selectCompare(group, this.exam);
  }

  generateExamsFromGroup(exam, groupKey) {
    let newExam, results = [];
    exam[groupKey].forEach(e => {
      newExam = Object.assign({}, exam);
      newExam.scanType = e.scanType;
      newExam.octDateButtonText = exam.dateDisplay + " - " + e.groupSeriesType + " (" + exam.exSrNo + ")";
      newExam[groupKey] = [e];
      results.push(newExam);
    });
    return results;
  }

  lockIfAble() {
    if (this.baseline && this.compare) {
      let compareScanType = store.getters.groups(this.compare.exam, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].scanType;
      let baselineScanType = store.getters.groups(this.baseline.exam, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].scanType
      this.lockEnabled = (this.compare && this.compare.browserType) === (this.baseline && this.baseline.browserType) && (compareScanType == baselineScanType);
      this.isLocked = this.lockEnabled ? true : false;
    }
    else
      this.isLocked = false;
  }

  toggleShowThicknessMap() {
    if (this.compare && this.compare.showThicknessMap)
      this.compare.showThicknessMap =  !this.compare.showThicknessMap;

    if (this.baseline && this.baseline.showThicknessMap) 
      this.baseline.showThicknessMap = !this.baseline.showThicknessMap;

    this.showThicknessMap = !this.showThicknessMap;
  }

  updateThicknessMapOpacity(opacity) {
    if (this.compare && this.compare.updateThicknessMapOpacity)
      this.compare.updateThicknessMapOpacity(opacity);
    if (this.baseline && this.baseline.updateThicknessMapOpacity)
      this.baseline.updateThicknessMapOpacity(opacity);
    this.thicknessMapOpacity = opacity;
  }

  calculateThicknessDifference() {
    if (this.compare && this.baseline && this.compare.measureData && this.baseline.measureData) {
      let difference =  (this.compare.measureData.convertedThickness - this.baseline.measureData.convertedThickness);
      let differencePercentage;
      if (difference > 0)
        differencePercentage = ((difference/this.compare.measureData.convertedThickness) * 100).toFixed(2);
      else
        differencePercentage = ((difference/this.baseline.measureData.convertedThickness) * 100).toFixed(2);
      this.thicknessDifference = difference.toFixed(2) + " μm (" + differencePercentage + "%)";
    }
  }

  isBothMeasuring() {
    this.bothMeasuring = (this.compare.isMeasuring && this.baseline.isMeasuring);
  }

  updateScanTypeFilter(val) {
    this.scanTypeFilter = val;
  }

  selectCompare(group, exam) {
    this.exam = exam;
    this.preferredBrowserType = group.browserType;
    this.compare = this.generateViewContext(group, exam, "compare");
    this.compare.loadImages = this.reloadImages;
    this.lockIfAble();
    this.checkThicknessCompare();
    return Promise.all([
      this.compare.startupTask(), 
      store.dispatch("tryGetBaselineContext", {launchOption: this.launchOption})]);
  }

  selectBaseline(group, exam) {
    if (!group || !exam) {
      if (this.baseline) this.baseline.clearContext();
      this.baseline = null;
      this.checkThicknessCompare();
      return Promise.resolve();
    }
    
    this.baseline = this.generateViewContext(group, exam, "baseline");
    this.baseline.loadImages = this.reloadImages;
    this.lockIfAble();
    this.checkThicknessCompare();
    return this.baseline.startupTask()
      .then(() => {
        this.checkThicknessCompare();
        if (this.isLocked) return store.dispatch("synchronizeOCTCompare");
      });
  }

  reloadChildrenContext() {
    this.reloadImages = true;
    if (this.compare && this.compare.exam) {
      let exam = this.exams.filter(e => e.exSrNo == this.compare.exam.exSrNo && e.scanType == this.compare.group.scanType);
      if (exam.length > 0) {
        this.compare.clearContext();
        this.selectCompare(this.compare.group, exam[0]);
      }
    }
    if (this.baseline && this.baseline.exam) {
      let exam = this.exams.filter(e => e.exSrNo == this.baseline.exam.exSrNo && e.scanType == this.baseline.group.scanType);
      if (exam.length > 0) {
        this.baseline.clearContext();
        this.selectBaseline(this.baseline.group, exam[0]);
      }
    }
    this.checkThicknessCompare();
  }

  setOCTImage(key, image) {
    if (this.compare && this.compare.exSrNo === image.exSrNo && this.compare.groupName === image.groupName) this.compare.setOCTImage(key, image);
    else if (this.baseline && this.baseline.exSrNo === image.exSrNo && this.baseline.groupName === image.groupName) this.baseline.setOCTImage(key, image);
  }
  
  checkThicknessCompare() {
    if (this.baseline && this.compare) {
      let compareScanType = store.getters.groups(this.compare.exam, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].scanType;
      let baselineScanType = store.getters.groups(this.baseline.exam, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].scanType;
      let compareSeriesType = store.getters.groups(this.compare.exam, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].groupSeriesType.toLowerCase();
      let baselineSeriesType = store.getters.groups(this.baseline.exam, this.eye, this.currentOCTBrowserType, this.preferredBrowserType)[0].groupSeriesType.toLowerCase();
      let isSameSeriesType = ((compareSeriesType.includes("volume") && baselineSeriesType.includes("volume")) || 
        (compareSeriesType.includes("cube") && baselineSeriesType.includes("cube"))) ? true : false;
      if (baselineScanType != compareScanType || (compareScanType != "volume" && compareScanType != "cube") || !isSameSeriesType)
        this.showThicknessMap = false;
      else
        this.showThicknessMap = true;
    }
    else
      this.showThicknessMap = false;
  }
}